import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleUnsavedViewModal, saveView, showAlertModal } from '../../actions';
import Dialog from '../common/Dialog'

const UnsavedViewModal = props => {
  const {
    view,
    cameras,
    compositeCams,
    deviceIdList,
    userViews,
    user,
    token,
    onCloseUnsavedViewModal,
    toggleUnsavedViewModal,
    saveView,
    showAlertModal,
  } = props

  const MASTER_CUSTOMER = 1 // Dividia's JSCustomer.bID
  const [viewId, setViewId] = useState(0)
  const [viewName, setViewName] = useState('')

  useEffect(() => {
    setViewId(0)
    setViewName('')

    if (Object.keys(view).length > 0) {
      setViewId(view.id)
      setViewName(view.label)
    }
  }, [view])

  const closeModal = () => {
    if (onCloseUnsavedViewModal) {
      onCloseUnsavedViewModal()
    }
    toggleUnsavedViewModal(false, null)
  }

  const saveViewChanges = () => {
    const cams = compositeCams.filter(c => c !== 0)

    if (!viewId && viewName.trim() === '') {
      showAlertModal(['WARNING', 'Please provide a name for the View.'])
      return
    }

    if (cams.length === 0) {
      showAlertModal(['WARNING', 'Cannot save an empty View. Please add cameras first.'])
      toggleUnsavedViewModal(false, null)
      return
    }

    // if this view has a mixture of cameras from different customers (which is only possible is user is a master admin), then assign Dividia as the customer
    // else, assign the camera's customer (which is also the user's customer since we only show cameras that are under the same customer of the user)
    const customerIds = cameras.filter(c => cams.includes(c.bID)).map(c => c.bCustomerID)
    const uniqueIds = [...new Set(customerIds)]
    const customerId = uniqueIds.length > 1 ? MASTER_CUSTOMER : parseInt(uniqueIds[0])

    saveView(viewId, viewName, customerId, compositeCams, user, userViews, deviceIdList, token, showAlertModal)
  }

  const message = onCloseUnsavedViewModal
    ? "There are unsaved changes in the current view. Would you like to save it first?"
    : "Are you sure you want to save this view?"

  return (
    <Dialog
      title={"Save " + viewName + " View"}
      boxStyle={{width: '50vmin'}}
      content={(
        <div style={styles.dialogContent}>
          <div>{message}</div>
          <div style={styles.note}>
            <p>Things to consider:</p>
            <ul>
              <li>If there are empty slots between cameras, empty slots will be ignored and cameras will be moved accordingly</li>
              <li>If cameras in the grid are from different customers, View's ownership will be changed to master customer (Dividia)</li>
            </ul>
          </div>
          {viewId === 0 &&
            <div>
              <p>To save, please provide a view name:</p>
              <input type="text" style={styles.input} defaultValue={viewName} onChange={(e) => setViewName(e.target.value)} />
            </div>
          }
        </div>
      )}
      buttons={[
        {label: 'Save', onClick: saveViewChanges},
        {label: 'Cancel', onClick: closeModal}
      ]}
    />
  )
}


const mapStateToProps = state => {
  const { compositeCams, deviceIdList, userViews, cameras } = state.data
  const { user, token } = state.auth
  const { onCloseUnsavedViewModal } = state.live
  return {
    cameras,
    compositeCams,
    deviceIdList,
    userViews,
    user,
    token,
    onCloseUnsavedViewModal,
  }
}

export default connect(mapStateToProps, { toggleUnsavedViewModal, saveView, showAlertModal })(UnsavedViewModal);

const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    fontSize: '1.6vmin',
    textAlign: 'left',
  },
  note: {
    textAlign: 'left',
  },
  input: {
    width: '100%',
  },
}